import Link from 'next/link';

const DevelopmentSection = ({
  leftHeading,
  leftDescription,
  leftButton,
  rightItems
}) => {
  return (
    <div className='w-full flex justify-center items-center bg-[#F0F0F0] lg:px-20 lg:py-20 px-10 py-10 max-w-[1750px] mx-auto' id='explore'>
      <div className='flex md:flex-row flex-col justify-between gap-10 w-full'>
        {/* left section */}
        <div className='md:w-[50%] flex flex-col lg:gap-y-10 gap-y-8'>
          <div className='w-[70%]'>
            <h2 className='text-[#172554] lg:text-4xl text-2xl font-inter font-bold lg:!leading-[130%] w-full'>
              {leftHeading}
            </h2>
          </div>
          <div>
            <p className='text-[#686868] lg:text-lg text-sm  font-normal lg:leading-7 w-[90%]'>
              {leftDescription}
            </p>
          </div>
          {leftButton && (
            <div>
              <Link href={leftButton.href}>
                <button
                  type="button"
                  className="text-white bg-[#046DEB] md:font-medium font-normal rounded-full sm:text-xs lg:text-base  transition-all duration-300 ease-out hover:scale-105 hover:bg-[#0056b3]  lg:px-8 lg:py-3 px-6 py-2 text-center">
                  {leftButton.text}
                </button>
              </Link>
            </div>
          )}
        </div>
        {/* right section */}
        <div className="md:w-[50%] flex flex-col justify-center gap-y-10">
          {rightItems && rightItems.map(({ subHeading, text }, index) => (
            <div key={index} className='flex flex-col gap-y-2'>
              <div className="w-[80%] text-[#046DEB] font-bold text-2xl !leading-[130%]">
                <h2>{subHeading}</h2>
              </div>
              <div className="text-[#686868] font-inter lg:text-lg text-sm font-normal lg:leading-7 ">
                <p>{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DevelopmentSection; 